module.exports = __webpack_public_path__ + "media/images/sidebar/sidebar-bg-3b9faea4025566d06654e516bb0fec02.jpg";